import jQuery from "jquery";

export default class lookup_person {
  constructor(element) {
    jQuery(element).keyup(function () {
      //always remove verified so its only there
      //if we have a valid personalnumber
      let defaultMsg =
        "Vi hämtar din adress med hjälp av folkbokföringens uppgifter. Var god vänta.";
      jQuery(element).removeClass("verified");
      jQuery(element).removeClass("not-verified");
      if (!(defaultMsg === jQuery("#edit-personnummer--description").html())) {
        jQuery("#edit-personnummer--description").html(defaultMsg);
        jQuery("#edit-actions-wizard-next").prop("disabled", true);
      }
      let value = jQuery(element).val();
      if (value.length != 12 && value.length != 10) {
        if (value.length == 13 && value.charAt(8) == "-") {
          value = value.replace("-", "");
        } else {
          jQuery("#edit-personnummer--description").html(
            "Fyll i ditt personnummer enligt ÅÅÅÅMMDDXXXX",
          );
          return;
        }
      }
      
      if (value.length == 10) {
        value = "19" + value;
      } else if (value.length == 12) {
        // Check if the century is plausible (e.g., not 18xx)
        let century = value.substring(0, 2);
        if (century !== "19" && century !== "20") {
          jQuery("#edit-personnummer--description").html(
            "Ange ett giltigt århundrade (19 eller 20)",
          );
          return;
        }
      }
      
      // match 10-13 characters (with possible dash)
      if (value.match(/^\d{6}(\d{2})?-?\d{4}$/)) {
        value = value.replace("-", ""); // Remove the dash
        if (value.match(/^\d{10}$/)) {
          // We are missing the century
          let entered_year = value.substring(0, 2); // eg. 37
          let currentTime = new Date();
          let fullyear = currentTime.getFullYear();
          let year = fullyear.toString();
          let current_year = year.substring(2);
          let current_century = year.substring(0, 2);
          let prefix =
            entered_year < current_year ? current_century : current_century - 1;
          value = prefix + value;
        }
        let mysoftready = value.slice(-10);
        jQuery("#personalnumber").val(mysoftready);
        jQuery.ajax({
          url: "/lookup_person/" + value,
          dataType: "json",
          success: function (data) {
            jQuery("#firstname").val(data.firstname);
            jQuery("#surname").val(data.surname);
            jQuery("#fn_masked").val(data.fn_masked);
            jQuery("#sn_masked").val(data.sn_masked);
            jQuery("#address").val(data.address);
            jQuery("#postalnumber").val(data.postalnumber);
            jQuery("#city").val(data.city);
            jQuery("#deliveryaddress2").val(data.deliveryaddress2);
            jQuery("#ad_masked").val(data.ad_masked);
            let responseMsg = "";
            if (data.firstname && data.surname) {
              jQuery(element).removeClass("not-verified");
              jQuery(element).addClass("verified");
              jQuery("#edit-actions-wizard-next").prop("disabled", false);
              responseMsg =
                "<strong>" +
                data.fn_masked +
                " " +
                data.sn_masked +
                "<br>" +
                data.ad_masked +
                "<br>Inte du?</strong> <button id='reset-personal-info-btn'>–Fyll i personnummer igen.</button><br><span id='enter-address-info-btn'>–Jag vill ange en annan adress än den jag är folkbokförd på.</span>";
            } else {
              jQuery(element).removeClass("verified");
              jQuery(element).addClass("not-verified");
              jQuery("#edit-actions-wizard-next").prop("disabled", true);
              responseMsg =
                "Det personnummer du angett ger inget resultat folkbokföringens namnuppgifter. <strong><button id='reset-personal-info-btn'>Fyll i personnummer igen.</button></strong>";
            }
            if (
              !(
                responseMsg === jQuery("#edit-personnummer--description").html()
              )
            ) {
              jQuery("#edit-personnummer--description").html(responseMsg);
              jQuery("#reset-personal-info-btn").on("click", function () {
                jQuery(element).val("");
                jQuery("#edit-personnummer--description").html(defaultMsg);
                jQuery(element).removeClass("verified");
                jQuery(element).removeClass("not-verified");
              });
              jQuery("#enter-address-info-btn").on("click", function () {
                jQuery("#edit-address").toggleClass("u-visually-hidden");
              });
            }
          },
        });
      }
    });
  }
}
